import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Send } from "lucide-react";

export const ChatInput = ({ disabled, onSend }: any) => {
  const [input, setInput] = useState("");

  const handleSend = () => {
    if (!input.trim()) return;
    onSend(input);
    setInput("");
  };

  return (
    <div className="flex gap-2">
      <Input
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && handleSend()}
        placeholder="Type your question..."
        disabled={disabled}
      />
      <Button onClick={handleSend} disabled={disabled} size="icon" aria-label="Send message">
        <Send className="h-4 w-4" />
      </Button>
    </div>
  );
};
